import type { ReactNode } from 'react';
import { Icon } from '@/components/foundations';
import { Button } from './Button';
import { CopyField, type CopyFieldProps } from './CopyField';

export type ApiKeyFieldProps = {
  id: string;
  /** Prefixo do ambiente, ex.: `sk_test_` ou `sk_live_`. */
  prefix: string;
  secret: string;
  /** Últimos caracteres mostrados com a chave oculta. */
  last4?: string;
  revealed: boolean;
  onToggle: () => void;
  copyLabel?: string;
};

export const maskKey = (prefix: string, last4: string) => `${prefix}${'•'.repeat(20)}${last4}`;

/** Linha da chave secreta: campo com copiar + botão Revelar/Ocultar (`.keyrow`). */
export function ApiKeyField({ id, prefix, secret, last4 = secret.slice(-4), revealed, onToggle, copyLabel = 'Copiar chave' }: ApiKeyFieldProps) {
  const value = revealed ? `${prefix}${secret}` : maskKey(prefix, last4);
  return (
    <KeyRow field={{ id, value, copyLabel }}>
      <Button variant="outline-gold" className="btn-reveal" id="reveal" type="button" onClick={onToggle} aria-pressed={revealed}>
        <Icon name="eye" />
        <span>{revealed ? 'Ocultar' : 'Revelar'}</span>
      </Button>
    </KeyRow>
  );
}

/** Campo + ação lado a lado (`.keyrow`), ex.: ID do item Pluggy + Conectar. */
export function KeyRow({ field, children }: { field: CopyFieldProps; children: ReactNode }) {
  return (
    <div className="keyrow">
      <CopyField {...field} />
      {children}
    </div>
  );
}
